import { createFileRoute } from '@tanstack/react-router';

import { SupplierOrderDetailPage } from '@/features/supplier/order-detail-page';

export const Route = createFileRoute('/_app/supplier/$orgId/orders/$poId')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <SupplierOrderDetailPage {...params} />;
}
